const LOG_TIME_ZONE = 'Europe/Zurich';
const MINUTES_PER_HOUR = 60;
const MILLISECONDS_PER_MINUTE = 60_000;

let logTimestampFormatter: Intl.DateTimeFormat | undefined;

function getLogTimestampFormatter(): Intl.DateTimeFormat {
  // en-CA liefert lateinische Ziffern; h23 nutzt 00:00 für Mitternacht.
  logTimestampFormatter ??= new Intl.DateTimeFormat('en-CA', {
    timeZone: LOG_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });
  return logTimestampFormatter;
}

function formatOffset(offsetMinutes: number): string {
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absoluteOffset = Math.abs(offsetMinutes);
  const hours = Math.floor(absoluteOffset / MINUTES_PER_HOUR);
  const minutes = absoluteOffset % MINUTES_PER_HOUR;

  return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

function formatZurichTimestamp(date: Date): string {
  const parts = Object.fromEntries(
    getLogTimestampFormatter()
      .formatToParts(date)
      .map(({ type, value }) => [type, value])
  );
  const { year, month, day, hour, minute, second } = parts;
  if (!year || !month || !day || !hour || !minute || !second) {
    throw new RangeError('Incomplete log timestamp parts');
  }

  const milliseconds = date.getUTCMilliseconds();
  // Die Zürcher Lokalzeit wird als UTC interpretiert; die Differenz zur Originalzeit ergibt den DST-sicheren Offset.
  const localTimeAsUtc = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    milliseconds
  );
  const offsetMinutes = Math.round((localTimeAsUtc - date.getTime()) / MILLISECONDS_PER_MINUTE);

  return (
    `${year}-${month}-${day}` +
    `T${hour}:${minute}:${second}` +
    `.${String(milliseconds).padStart(3, '0')}${formatOffset(offsetMinutes)}`
  );
}

export function formatLogTimestamp(date = new Date()): string {
  try {
    return formatZurichTimestamp(date);
  } catch {
    return date.toISOString();
  }
}
